// src/Dashboard/pages/user/Produits/utils/productsUtils.js

export const PRODUCTS_API_URL =
  process.env.REACT_APP_PRODUCTS_API_URL ||
  "https://api.monappliclub.com/api/productsapp/allproductsapp";

export const FALLBACK_PRODUCT_IMAGE = "/img/no-image.jpg";

export const DEFAULT_PRODUCTS_UI = {
  q: "",
  sort: "order",
};

export const DEVELOPER_PROFILE = {
  name: "Laurent VICTORIN",
  role: "Développeur Web & Web Mobile · Président & Enseignant de Judo",
  email: "monappliclub@gmail.com",
  phoneDisplay: "06 80 72 77 07",
  phoneHref: "+33680727707",
  photo:
    "https://res.cloudinary.com/dj0c0zuje/image/upload/v1744184384/PXL_20241115_211013575.MP_1_h7lbn9.jpg",
  website: "https://www.monappliclub.com/",
  vkard:
    "https://profile.vkard.io/8f8e4d95-cf28-40b0-afc6-2ec677889d49/ab099714aa",
};

export const DONATION_LINKS = [
  {
    label: "5 €",
    subtitle: "Don unique",
    url: "https://buy.stripe.com/cN2aFtaqL5fC1AkcMR",
  },
];

export const collatorFR = new Intl.Collator("fr", {
  sensitivity: "base",
});

export const ensureHttp = (url = "") => {
  const value = String(url || "").trim();
  if (!value) return "";
  return /^https?:\/\//i.test(value) ? value : `https://${value}`;
};

export const toAbsoluteMediaUrl = (url = "") => {
  const value = String(url || "").trim();

  if (!value) return "";

  if (
    /^https?:\/\//i.test(value) ||
    value.startsWith("data:") ||
    value.startsWith("blob:")
  ) {
    return value;
  }

  if (!value.startsWith("/uploads")) {
    return value;
  }

  const base = process.env.REACT_APP_API_URL?.replace(/\/$/, "") || "";

  return `${base}${value}`;
};

export const parseDemoLinks = (input) => {
  if (Array.isArray(input)) {
    return input.map((item) => String(item || "").trim()).filter(Boolean);
  }

  return String(input || "")
    .split(/[;\n]/)
    .map((item) => item.trim())
    .filter(Boolean);
};

export const hostLabel = (url, index = 0) => {
  try {
    const parsed = new URL(ensureHttp(url));
    return parsed.hostname.replace(/^www\./, "");
  } catch {
    return `Démo ${index + 1}`;
  }
};

export const getProductName = (product) => {
  return String(product?.nom_app || "").trim() || "Application";
};

export const getProductDescription = (product) => {
  return (
    String(product?.description_app || "").trim() ||
    "Description non renseignée."
  );
};

export const getProductImage = (product) => {
  return toAbsoluteMediaUrl(product?.image_url_app) || FALLBACK_PRODUCT_IMAGE;
};

export const filterAndSortProducts = (products = [], ui = DEFAULT_PRODUCTS_UI) => {
  const query = String(ui.q || "").trim().toLowerCase();

  const filtered = (products || []).filter((product) => {
    const name = String(product?.nom_app || "").toLowerCase();
    const description = String(product?.description_app || "").toLowerCase();

    return !query || name.includes(query) || description.includes(query);
  });

  return filtered.slice().sort((a, b) => {
    if (ui.sort === "alpha") {
      return collatorFR.compare(getProductName(a), getProductName(b));
    }

    return (
      Number(a?.ordre_app ?? 0) - Number(b?.ordre_app ?? 0) ||
      collatorFR.compare(getProductName(a), getProductName(b))
    );
  });
};

export const getProductsShareUrl = (ui) => {
  const params = new URLSearchParams();

  if (ui.q) {
    params.set("q", ui.q);
  }

  if (ui.sort && ui.sort !== DEFAULT_PRODUCTS_UI.sort) {
    params.set("sort", ui.sort);
  }

  const query = params.toString();

  return `${window.location.origin}${window.location.pathname}${
    query ? `?${query}` : ""
  }`;
};

export const truncateText = (value = "", max = 140) => {
  const text = String(value || "").trim();

  if (text.length <= max) return text;

  return `${text.slice(0, max).trim()}…`;
};